export enum DataSourceTypes
{
    PublicData = 1,
    EYIP = 2,
    BYOD = 3,
    UploadURL =4,
    Experts = 5,
    DeepResearch = 9
}

